//
// AccessibilityController.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import ClosetObject from "../ClosetObject";
import "../lib";
import "./AccessibilityElement";
import "../models/BaseModel";
import "./sonification/SonificationController";

var AccessibilityController = createModule("commons_AccessibilityController", [10001], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        nextAccessibilityElement: [0],
        getCurrentAccessibilityElement: [1],
        getModel: [1],
        _getAccessibilityElements_n: [[1],4],
        isOnScreen: [2,1],
        previousAccessibilityElement: [0],
        getAccessibilityElement: [1,4,2],
        setFocus: [0,1],
        getLoopOn: [2],
        setLoopOn: [0,2],
        getDataFrame: [12],
        getSonificationController: [1],
        _getAccessibilityElements_v: [[1]],
    },
    ,
    ["getAccessibilityElements"],
]);
export default AccessibilityController;
